import {AutogenLayoutMpactControl} from "./autogen/AutogenLayoutMpactControl";
import {ChangeEvent, DataSourceMode, LayoutProps} from "@mcleod/components";
import {ModelRow, StringUtil, UserSettings} from "@mcleod/core";


interface controlLayoutProps extends LayoutProps {
    vendorId: string;
}

export class MpactControl extends AutogenLayoutMpactControl{
    private _vendorId: string;

    constructor(props?: Partial<controlLayoutProps>) {
        super(props);
        this._vendorId = props?.vendorId;
    }

    async onLoad() {
        this.setupMpactControlFields();


        this.mainDataSource.addAfterModeChangeListener(event => {
            if (event.newMode === DataSourceMode.ADD) {
                if (this.mainDataSource.activeRow == null) {
                    return;
                }
                this.activeRow.setValues(this.activeRow?.get("mpact_default_values"));
            }
        });
        this.sourceMarketrateExprt.addAfterModeChangeListener(event => {
            if (event.newMode === DataSourceMode.ADD) {
                if (this.sourceMarketrateExprt.activeRow == null) {
                    return;
                }
                this.sourceMarketrateExprt.activeRow.setValues(this.sourceMarketrateExprt.activeRow?.get("mcleod_default_values"));
            }
        });
    }

    async postDataSources(vendorId: string): Promise<boolean> {
        try {
            if(!this.validateRequiredFields(this.mainDataSource?.activeRow)){
                await this.mainDataSource.post();
                return false;
            }
            this.sourceMarketrateExprt?.activeRow?.set("vendor","M");
            this.sourceMarketrateExprt?.activeRow?.set("is_active", this.sourceExchangeControl?.activeRow?.get("join_exchange"));
            this.sourceMarketrateExprt?.activeRow?.set("user_name", this.mainDataSource?.activeRow?.get("user_name"));
            this.sourceMarketrateExprt?.activeRow?.set("password", this.mainDataSource?.activeRow?.get("password"));
            if(!this.sourceMarketrateExprt?.activeRow?.get("account_number")){
                this.sourceMarketrateExprt?.activeRow?.set("account_number", "1");
            }
            await this.sourceMarketrateExprt.post();

            this.sourceExchangeControl?.activeRow?.set("username", this.mainDataSource?.activeRow?.get("user_name"));
            this.sourceExchangeControl?.activeRow?.set("passwd", this.mainDataSource?.activeRow?.get("password"));
            this.sourceExchangeControl?.activeRow?.set("url", this.mainDataSource?.activeRow?.get("webservice_address"));
            this.sourceExchangeControl?.activeRow?.set("scac",UserSettings.getSingleton().getCompanySCAC());
            await this.sourceExchangeControl.post();

            this.mainDataSource?.activeRow?.set("vendor", vendorId);
            await this.mainDataSource.post();
            return true;
        } catch (error) {
            return false;
        }
    }
    switchUseMarketRateFuelSurchargeOnChange(event: ChangeEvent){
        this.textboxCustomerId.visible = event.newValue === false;
        this.textboxCustomerId.required = event.newValue === false;
    }

    switchEnableMarketInsightOnChange(event:ChangeEvent){
        this.panelMarketExportSection.visible = event.newValue;
        this.marketInsightPanel.visible = event.newValue;
    }


    private setupMpactControlFields() {
        this.switchInternalRates.caption = StringUtil.isEmptyString(UserSettings.getSingleton().getCompanySCAC()) ? "Display Internal Rates" : "Display " + UserSettings.getSingleton().getCompanySCAC() + " Rates";
        this.layoutRateIndexGeneral.textboxDashboardUrl.visible = false;
        this.layoutRateIndexGeneral.textboxDashboardUrl.required = false;
        this.layoutAdditionalOptions.textboxMilesPerGallon.visible = false;
        this.layoutAdditionalOptions.textboxMilesPerGallon.required = false;
        this.layoutAdditionalOptions.textboxSearchRange.visible = false;
        this.layoutAdditionalOptions.textboxSearchRange.required = false;

    }

    private validateRequiredFields(activeRow: ModelRow | undefined) {
        return activeRow?.get("user_name") && activeRow?.get("password") && activeRow?.get("integration_id") && activeRow?.get("webservice_address");
    }
}
